module.exports = __webpack_public_path__ + "static/media/webpage-after.bee0e92c.jpg";